var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuleSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C5.79108 0 3.79008 0.896229 2.34315 2.34314L2.34314 2.34315C0.896229 3.79008 0 5.79108 0 8C0 10.2089 0.896229 12.2099 2.34314 13.6568L2.8574 13.1426L2.34315 13.6568C3.79008 15.1038 5.79108 16 8 16C10.2089 16 12.2099 15.1038 13.6568 13.6568C15.1038 12.2099 16 10.2089 16 8C16 5.79108 15.1038 3.79008 13.6568 2.34315L13.1426 2.8574L13.6568 2.34314C12.2099 0.896229 10.2089 0 8 0ZM3.37166 3.37167C4.55697 2.18637 6.19234 1.45455 8 1.45455C9.80766 1.45455 11.443 2.18637 12.6283 3.37166C13.8136 4.55697 14.5455 6.19234 14.5455 8C14.5455 9.80766 13.8136 11.443 12.6283 12.6283C11.443 13.8136 9.80766 14.5455 8 14.5455C6.19234 14.5455 4.55697 13.8136 3.37166 12.6283C2.18637 11.443 1.45455 9.80766 1.45455 8C1.45455 6.19234 2.18637 4.55698 3.37166 3.37167ZM7.43666 10.6692L11.7464 6.35943L10.7179 5.33091L6.9224 9.12642L5.28178 7.48579L4.25326 8.51431L6.40814 10.6692L6.9224 11.1835L7.43666 10.6692Z",
    fill: "#97FF9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuleSuccess);
export default __webpack_public_path__ + "static/media/rule-success.1e668c954bb95c08c8e55079ff297820.svg";
export { ForwardRef as ReactComponent };